import React from "react";

const MapCard = ({ data }) => {



    let mapDetails = null;

    try {
        mapDetails =
            typeof data === "string" && data.trim()
                ? JSON.parse(data)
                : data;
    } catch (err) {
        console.error("Invalid map JSON:", data);
        return null; // or fallback UI
    }

    if (!mapDetails?.latitude || !mapDetails?.longitude) {
        return null;
    }

    // const mapUrl = `https://maps.google.com/maps?q=${data?.latitude},${data?.longitude}&z=15&output=embed`;
    const mapUrl = `https://maps.google.com/maps?q=${mapDetails?.latitude},${mapDetails?.longitude}&z=15&output=embed&markers=color:red%7C${mapDetails?.latitude},${mapDetails?.longitude}`;
    // const mapUrl = `https://www.google.com/maps?q=${data?.latitude},${data?.longitude}&hl=es;z=14&output=embed`;
    return (
        <div className="bg-white p-4 rounded-xl shadow border ">

            <div className="w-full h-40 rounded-lg overflow-hidden">
                <iframe
                    title='map'
                    width="100%"
                    height="100%"
                    loading="lazy"
                    allowFullScreen
                    src={mapUrl}
                    style={{ border: 0 }}
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
        </div>
    );
};


export default MapCard;
